import { motion } from "framer-motion";

export const ApplicationGetWays = () => {

    return (
        <>
            <h1 className="section-headers">APPLICATION GETWAYS</h1>
            <div className="requirements">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>ARTHUR GOOGLE FORM APPLICATION (AGFA)</h3>
                    <hr />
                    <p><a href="/AGFA/apply" target="_blank">click here to apply through AGFA</a></p>
                    <h3 style={{ color: "white" }}>
                        For this type of application, you will not be able to track your progress through our system. <br /><br />
                        Instead, our admissions team will contact you directly via the email or WhatsApp number you provide in the form to update you on the status of your application.
                    </h3>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 2 }}
                    viewport={{ once: false, amount: 0.1 }}
                    className="requirement card">
                    <h3>ARTHUR APPLICATION SYSTEM (AAS)</h3>
                    <hr />
                    <p><a href="/apply" target="_blank">click here to apply through AAS</a></p>
                    <h3 style={{ color: "white" }}>
                        You will need to create an AAS account to start your application. <br /><br />
                        Through your AAS account, you will be able to track the progress of your application, including statuses such as <i>(submitted, received, rejected, approved)</i>. <br /><br />
                        You can also submit multiple applications and conveniently track the progress of all of them in one place, right from your AAS account.
                    </h3>
                </motion.div>

            </div>
        </>
    )
}